import React from 'react';

const SecuredFooter = () => (
	<div className="flex w-full items-center justify-center gap-[8px] pt-[4px] text-[12px] text-pay-muted">
		<p className="font-medium">🔒 Secured by Stripe</p>
		<p>•</p>
		<p className="font-medium">Powered by Perfect Day</p>
	</div>
);

export default SecuredFooter;
